<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Cadastrar Justificativa
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="section-form">
                                <form id="form">
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <label>
                                                <span class="required">*</span>
                                                Justificativa:
                                            </label>
                                            <textarea
                                                v-model="justifications.description"
                                                class="form-control"
                                                cols="30"
                                                rows="6"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div class="block text-right">

                                        <router-link
                                            to="/justifications"
                                            class="btn btn-back"
                                        >
                                            <i class="fa fa-arrow-left mr-2"></i>
                                            Voltar
                                        </router-link>

                                        <a
                                            class="btn btn-add"
                                            @click="save"
                                        >
                                            Salvar
                                            <i class="fa fa-save ml-2"></i>
                                        </a>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            justifications: {
                title: "",
                description: "",
            },

            errors: undefined,
        };
    },
    computed: {},
    methods: {
        save: function () {
            const api = this.$store.state.api + "justifications";
            const self = this;

            self.$http
                .post(api, self.justifications)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Justificativa cadastrada com sucesso`,
                        "success"
                    );
                    this.$router.push("/justifications");
                })
                .catch((error) => {
                    self.errors = error.response.data;

                    if (typeof self.errors === "object") {
                        let html = "<ul>";

                        $.each(self.errors, function (key, value) {
                            html += "<li>" + value[0] + "</li>";
                        });

                        html += "</ul>";

                        self.errors = html;
                    }

                    self.$message(null, self.errors, "error");
                });
        },
    },
    mounted: function () {
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Justification/Add.vue